import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { createOfflineFilterOptionsRepository } from './filterOptions/createOfflineFilterOptionsRepository';

const commonRepository = createOfflineCommonRepository(() => offlineDatabase.deliveryWindows);

const filterOptionsRepository = createOfflineFilterOptionsRepository(
  () => offlineDatabase.deliveryWindows,
  ['code', 'name'],
);

export const offlineDeliveryWindowsRepository = {
  ...commonRepository,
  ...filterOptionsRepository,
};
